import Section from "../../common/Section/Section"
import IndustryInfoSection from "./IndustryInfoSection"
import IndustryCaseStudySection from "./IndustryCaseStudySection"
import equipmentMain from "../../../assets/img/industries/equipment/equipment_main.webp"
import equipmentCaseStudy from "../../../assets/img/industries/equipment/equipment_case_study.jpg"


export default function Equipment() {
 const caseStudyInfo = {
  title: "Equipment Case Study", description: (<>
   <p>A European client, having transitioned from oil & gas to renewable energy over the past 12 years, adopted equi-track to support their inspection, maintenance, and wind farm installation operations. With equipment warehouses in six locations across Europe, they needed a solution that was simple for field technicians to use, yet powerful enough to give management clear insights into utilisation, productivity, and cost control.  </p>
   <p>equi-track’s intuitive interface ensures that, regardless of users’ digital experience, complex tasks are easy and accurate to perform. By handling the difficult parts behind the scenes, equi-track enables teams to focus on their work while management benefits from real-time, actionable information. </p>
  </>),
  img: equipmentCaseStudy
 }

 const industryInfo = {
  description: (<>
   <ul className="list-unstyled">
    <li className="py-2"><strong>Unified Equipment Overview:</strong> Give your team instant access to all equipment details—inventory, quotes, documentation, and hire contracts—boosting productivity and visibility.
    </li>
    <li className="py-1 py-lg-3"><strong>Full Asset & Parts Management:  </strong> Track equipment and stock from warehouse to job site, with every movement and allocation recorded in equi-track.</li>
    <li className="py-1 py-lg-3"><strong>Business System Integration:</strong> Connect seamlessly with your finance and admin software for efficient, accurate operations.</li>
    <li className="py-1 py-lg-3"><strong>Insightful Utilisation Reporting:  </strong> Understand exactly how efficiently you’re using your equipment— equi-track provides the data you need to optimise usage and reduce costs.</li>
   </ul>
  </>),
  img: equipmentMain
 }

 return (
  <Section title="equi-track for Equipment" isIndustryPage>
   <IndustryInfoSection industryInfo={industryInfo} />
   <IndustryCaseStudySection caseStudyInfo={caseStudyInfo} />
  </Section>
 )
}